import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";
import authSlice from "../features/common/authSlice";
import couponReducer from "../features/common/couponSlice";
import userReducer from "../features/common/userSlice";
import bookingReducer from "../features/common/bookingSlice";
import configurationReducer from "../features/common/configurationSlice";
import packageReducer from "../features/common/packageSlice";
import destinationReducer from '../features/common/destinationSlice';
import flightCountryListReducer from '../features/common/flightSearchListSlice';
import popularDestinationReducer from "../features/common/popularDestinationsSlice";
import categoryReducer from "../features/common/categorySlice";
import packageDeginationReducer from "../features/common/packageDeginationSlice";
import convenienceFeesAndChargesReducer from "../features/common/convenienceFeesAndChargesSlice";
import logReducer from "../features/common/logSlice";
import hiddenFareRuleReducer from "../features/common/hiddenFareRuleSlice";
import tboHotelSlice from "../features/common/tboHotelSlice";
import syncTboHotelSlice from "../features/common/syncTboHotelSlice";
import travellerReducer from "../features/common/travellerSlice";
import feedbackReducer from "../features/common/feedbackSlice";

const combinedReducer = {
  header: headerSlice,
  auth: authSlice,
  coupon: couponReducer,
  user: userReducer,
  booking: bookingReducer,
  package: packageReducer,
  configuration: configurationReducer,
  destinations: destinationReducer,
  flightList: flightCountryListReducer,
  populardestination: popularDestinationReducer,
  category: categoryReducer,
  packageDegination: packageDeginationReducer,
  convenienceFeesAndCharges: convenienceFeesAndChargesReducer,
  loglists: logReducer,
  hiddenFareRule: hiddenFareRuleReducer,
  tboHotel: tboHotelSlice,
  syncTboHotel: syncTboHotelSlice,
  traveller: travellerReducer,
  feedback: feedbackReducer,
};

export default configureStore({
  reducer: combinedReducer,
});
